import { createFileRoute, SearchSchemaInput } from "@tanstack/react-router";

import QuestDetailsForm from "@/components/QuestProfile/QuestDetailsForm";
import QuestOverview from "@/components/QuestProfile/QuestOverview";
import QuestTypeSelector from "@/components/QuestProfile/QuestTypeSelector";

const Component = () => {
  const search = Route.useSearch();
  return (
    <QuestOverview background={search.type ? undefined : "neutral.50"}>
      {!search.type ? <QuestTypeSelector /> : <QuestDetailsForm questType={search.type} />}
    </QuestOverview>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/create")({
  component: Component,
  validateSearch: ({
    type,
  }: { type?: string } & SearchSchemaInput): {
    type: "LEADERBOARD_POINTS" | undefined;
  } => {
    if (type === "LEADERBOARD_POINTS") {
      return { type };
    }
    return { type: undefined };
  },
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/loyalty/quests",
      },
    };
  },
});
